import * as leaseCellarChanges from 'constants/enums/leaseCellarChanges'

export default {
  [leaseCellarChanges.ADDING]: 'přidávám',
  [leaseCellarChanges.REMOVING]: 'ubírám',
  [leaseCellarChanges.NO_CHANGE]: 'beze změny',
}
